import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { AvatarModule } from '@libs/src/avatar/avatar.module';
import { ChipModule } from '@libs/src/chip/chip.module';
import { AccountJobTitlePipeModule } from '@main-client/src/app/pipes/account-job-title-pipe/account-job-title-pipe.module';
import { TranslationLookupModule } from '@main-client/src/app/pipes/translation-lookup/translation-lookup.module';
import { WrapMatchingStringsPipeModule } from '@main-client/src/app/pipes/wrap-matching-strings-pipe/wrap-matching-strings-pipe.module';

import { AccountCardKeywordSimilarityComponent } from './account-card-keyword-similarity/account-card-keyword-similarity.component';
import { AccountCardComponent } from './account-card.component';

@NgModule({
  imports: [
    AvatarModule,
    AccountJobTitlePipeModule,
    ChipModule,
    CommonModule,
    FlexLayoutModule,
    RouterModule,
    MatButtonModule,
    MatIconModule,
    WrapMatchingStringsPipeModule,
    TranslationLookupModule,
  ],
  declarations: [AccountCardComponent, AccountCardKeywordSimilarityComponent],
  exports: [AccountCardComponent, AccountCardKeywordSimilarityComponent],
})
export class AccountCardModule {}
